export default "__VITE_ASSET__CYe5OQuT__"